import AirplaneIcon from "./airplane.svg?component";
import ArrowRotateIcon from "./arrow-rotate.svg?component";
import ArrowSquareIcon from "./arrow-square.svg?component";
import ArrowsUpDownIcon from "./arrows-up-down.svg?component";
import BankIcon from "./bank.svg?component";
import BellIcon from "./bell.svg?component";
import CalendarIcon from "./calendar.svg?component";
import CaretLeftIcon from "./caret-left.svg?component";
import CaretRightIcon from "./caret-right.svg?component";
import CaretDownIcon from "./caret-down.svg?component";
import CaretUpIcon from "./caret-up.svg?component";
import CartIcon from "./cart.svg?component";
import ChartBarIcon from "./chart-bar.svg?component";
import CheckIcon from "./check.svg?component";
import ChevronDoubleLeftIcon from "./chevron-double-left.svg?component";
import ChevronDoubleRightIcon from "./chevron-double-right.svg?component";
import ChevronDownIcon from "./chevron-down.svg?component";
import ChevronLeftIcon from "./chevron-left.svg?component";
import ChevronRightIcon from "./chevron-right.svg?component";
import ChevronUpIcon from "./chevron-up.svg?component";
import CircleHelpIcon from "./circle_help.svg?component";
import ClockIcon from "./clock.svg?component";
import CoinIcon from "./coin.svg?component";
import CopyIcon from "./copy.svg?component";
import CSIcon from "./cs.svg?component";
import ClipboardCheckIcon from "./clipboard-check.svg?component";
import DocumentDownIcon from "./document-down.svg?component";
import DocumentStarIcon from "./document-star.svg?component";
import DocumentTextIcon from "./document-text.svg?component";
import DocumentTextEditIcon from "./document-text-edit.svg?component";
import DocumentTextSearchIcon from "./document-text-search.svg?component";
import DotIcon from "./dot.svg?component";
import DownloadIcon from "./download.svg?component";
import EditIcon from "./edit.svg?component";
import ExternalLinkIcon from "./external-link.svg?component";
import FileJpegIcon from "./file-jpeg.svg?component";
import FileJpgIcon from "./file-jpg.svg?component";
import FilePdfIcon from "./file-pdf.svg?component";
import FileXlsIcon from "./file-xls.svg?component";
import FileXlsxIcon from "./file-xlsx.svg?component";
import FileCsvIcon from "./file-csv.svg?component";
import FileDocIcon from "./file-doc.svg?component";
import FileDocxIcon from "./file-docx.svg?component";
import FilePptIcon from "./file-ppt.svg?component";
import FilePptxIcon from "./file-pptx.svg?component";
import FileTxtIcon from "./file-txt.svg?component";
import FileIcon from "./file.svg?component";
import FilterIcon from "./filter.svg?component";
import FolderIcon from "./folder.svg?component";
import FolderSolidIcon from "./folder-solid.svg?component";
import FrameIcon from "./frame.svg?component";
import GraphUpIcon from "./graph-up.svg?component";
import HeadSetIcon from "./head-set.svg?component";
import InfoCircleIcon from "./info-circle.svg?component";
import InfoIcon from "./info.svg?component";
import LinkIcon from "./link.svg?component";
import LogoMobileIcon from "./logo-mobile.svg?component";
import LogoIcon from "./logo.svg?component";
import MailIcon from "./mail.svg?component";
import MapPinIcon from "./map-pin.svg?component";
import MenuIcon from "./menu.svg?component";
import MinusIcon from "./minus.svg?component";
import MoreHorizontalIcon from "./more-horizontal.svg?component";
import NullIcon from "./null.svg?component";
import PackageIcon from "./package.svg?component";
import PlusIcon from "./plus.svg?component";
import ReceiptIcon from "./receipt.svg?component";
import SearchIcon from "./search.svg?component";
import SearchPlusIcon from "./search-plus.svg?component";
import StarSolidIcon from "./star-solid.svg?component";
import StarIcon from "./star.svg?component";
import TrashIcon from "./trash.svg?component";
import TruckIcon from "./truck.svg?component";
import UploadCloudIcon from "./upload-cloud.svg?component";
import UploadDataWindowIcon from "./upload-data-window.svg?component";
import UserIcon from "./user.svg?component";
import WarningCircleIcon from "./warning-circle.svg?component";
import WarningCircleSolidIcon from "./warning-circle-solid.svg?component";
import WarningTriangleSolidIcon from "./warning-triangle-solid.svg?component";
import WarningTriangleIcon from "./warning-triangle.svg?component";
import XCircleSolidIcon from "./x-circle-solid.svg?component";
import XCircleSolidCurrentColorIcon from "./x-circle-solid-current-color.svg?component";
import XCircleIcon from "./x-circle.svg?component";
import XIcon from "./x.svg?component";

const icons = {
  airplane: AirplaneIcon,
  "arrow-rotate": ArrowRotateIcon,
  "arrow-square": ArrowSquareIcon,
  "arrows-up-down": ArrowsUpDownIcon,
  bank: BankIcon,
  bell: BellIcon,
  calendar: CalendarIcon,
  "caret-left": CaretLeftIcon,
  "caret-right": CaretRightIcon,
  "caret-down": CaretDownIcon,
  "caret-up": CaretUpIcon,
  cart: CartIcon,
  "chart-bar": ChartBarIcon,
  check: CheckIcon,
  "chevron-double-left": ChevronDoubleLeftIcon,
  "chevron-double-right": ChevronDoubleRightIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  circle_help: CircleHelpIcon,
  clock: ClockIcon,
  coin: CoinIcon,
  copy: CopyIcon,
  cs: CSIcon,
  "clipboard-check": ClipboardCheckIcon,
  "document-down": DocumentDownIcon,
  "document-star": DocumentStarIcon,
  "document-text": DocumentTextIcon,
  "document-text-edit": DocumentTextEditIcon,
  "document-text-search": DocumentTextSearchIcon,
  dot: DotIcon,
  download: DownloadIcon,
  edit: EditIcon,
  "external-link": ExternalLinkIcon,
  "file-jpeg": FileJpegIcon,
  "file-jpg": FileJpgIcon,
  "file-pdf": FilePdfIcon,
  "file-xls": FileXlsIcon,
  "file-xlsx": FileXlsxIcon,
  "file-csv": FileCsvIcon,
  "file-doc": FileDocIcon,
  "file-docx": FileDocxIcon,
  "file-ppt": FilePptIcon,
  "file-pptx": FilePptxIcon,
  "file-txt": FileTxtIcon,
  file: FileIcon,
  filter: FilterIcon,
  folder: FolderIcon,
  "folder-solid": FolderSolidIcon,
  frame: FrameIcon,
  "graph-up": GraphUpIcon,
  "head-set": HeadSetIcon,
  "info-circle": InfoCircleIcon,
  info: InfoIcon,
  link: LinkIcon,
  "logo-mobile": LogoMobileIcon,
  logo: LogoIcon,
  mail: MailIcon,
  "map-pin": MapPinIcon,
  menu: MenuIcon,
  minus: MinusIcon,
  "more-horizontal": MoreHorizontalIcon,
  null: NullIcon,
  package: PackageIcon,
  plus: PlusIcon,
  receipt: ReceiptIcon,
  search: SearchIcon,
  "search-plus": SearchPlusIcon,
  "star-solid": StarSolidIcon,
  star: StarIcon,
  trash: TrashIcon,
  truck: TruckIcon,
  "upload-cloud": UploadCloudIcon,
  "upload-data-window": UploadDataWindowIcon,
  user: UserIcon,
  "warning-circle": WarningCircleIcon,
  "warning-circle-solid": WarningCircleSolidIcon,
  "warning-triangle-solid": WarningTriangleSolidIcon,
  "warning-triangle": WarningTriangleIcon,
  "x-circle-solid": XCircleSolidIcon,
  "x-circle-solid-current-color": XCircleSolidCurrentColorIcon,
  "x-circle": XCircleIcon,
  x: XIcon,
};

export default icons;
